/**
 * Data Provider Configuration
 *
 * To add a new provider, just add an entry to this array.
 * The UI and backend storage will handle it automatically.
 *
 * Each `field` becomes a row in the database:
 *   (user_id, provider, key=field.key, value=<user input>)
 */

export interface DataProviderField {
  /** Storage key — sent to the backend as the `key` column. */
  key: string;
  /** Human-readable label shown in the form. */
  label: string;
  /** Placeholder text for the input. */
  placeholder?: string;
  /** Whether to mask the input (password field). Defaults to true. */
  secret?: boolean;
}

export interface DataProviderConfig {
  /** Unique identifier stored in the database `provider` column. */
  id: string;
  /** Display name shown in the UI. */
  name: string;
  /** Short description of what this provider is for. */
  description: string;
  /** The fields the user must fill in. */
  fields: DataProviderField[];
}

// ---------------------------------------------------------------------------
// ADD YOUR PROVIDERS HERE
// ---------------------------------------------------------------------------

const DATA_PROVIDERS: DataProviderConfig[] = [
  {
    id: 'INSYNC',
    name: 'INSYNC',
    description: 'Portfolio synchronisation service',
    fields: [
      { key: 'user', label: 'Username', placeholder: 'user@company.com', secret: false },
      { key: 'password', label: 'Password', placeholder: 'Enter password' },
    ],
  },
  {
    id: 'FINRA',
    name: 'FINRA',
    description: 'Financial Industry Regulatory Authority data',
    fields: [
      { key: 'user', label: 'User ID', placeholder: 'Enter FINRA user ID', secret: false },
      { key: 'password', label: 'Password', placeholder: 'Enter FINRA password' },
    ],
  },
  {
    id: 'ODP',
    name: 'ODP',
    description: 'AWS-backed data platform',
    fields: [
      { key: 'aws_access_key_id', label: 'AWS Access Key ID', placeholder: 'AKIA...', secret: false },
      { key: 'aws_secret_access_key', label: 'AWS Secret Access Key', placeholder: 'Enter secret key' },
      { key: 'access_point_arn', label: 'Access Point ARN', placeholder: 'arn:aws:s3:...', secret: false },
      { key: 'client_prefix', label: 'Client Prefix', placeholder: 'e.g. 413579287786/', secret: false },
    ],
  },
  {
    id: 'FMP',
    name: 'Financial Modeling Prep',
    description: 'Market data, financials, and stock prices',
    fields: [
      { key: 'apikey', label: 'API Key', placeholder: 'Enter your FMP API key' },
    ],
  },
];

export default DATA_PROVIDERS;
